/*
  TrinkTiger – Sternify Geschenk-Reconcile (Claude Code)
  ------------------------------------------------------------------
  Sorgt dafuer, dass Gratis-Geschenke NIE ohne den zugehoerigen Brunnen
  (oder zum regulaeren Preis) im Warenkorb stehen bleiben – inkl. korrektem
  Neu-Rendern des Drawers (Leer-Zustand + Warenkorb-Badge).

  Erkennung eines Geschenks (robust):
    - Zeile hat die Property _sternify_gift_id (von Sternify gesetzt), UND
    - der Produkttitel enthaelt "GRATIS" (die dedizierten Geschenk-SKUs,
      z. B. "GRATIS Reinigungsset", "3x GRATIS Filter Set").
  Der Ausloeser-Brunnen traegt zwar ebenfalls _sternify_gift_id, heisst aber
  NICHT "GRATIS ..." -> wird niemals entfernt.

  Regeln:
   1) Jede Geschenk-Zeile mit final_line_price > 0 wird entfernt
      (verwaistes Geschenk zum regulaeren Preis).
   2) Sind ueberhaupt keine Nicht-Geschenk-Artikel mehr im Warenkorb, werden
      ALLE Geschenk-Zeilen entfernt (auch 0-Euro), damit Geschenke nie allein
      dastehen -> Warenkorb wird korrekt leer.

  Render: /cart/update.js mit sections:['cart-drawer','cart-icon-bubble']
  (Section-Rendering-API, exakt wie das Theme in cart-drawer.js/cart.js).
  Danach .drawer__inner + Badge ersetzen und is-empty auf <cart-drawer> setzen.
*/
(function () {
  'use strict';

  var ADD_DELAY = 800; // beim Hinzufuegen laenger warten (Sternify legt Geschenke async an)
  var CHANGE_DELAY = 120; // beim Aendern/Entfernen schnell reagieren
  var reconciling = false;
  var timer = null;

  function isGiftLine(it) {
    var p = it.properties || {};
    if (!p._sternify_gift_id) return false;
    var title = (it.product_title || it.title || '') + '';
    return title.toUpperCase().indexOf('GRATIS') !== -1;
  }

  function orphanLineKeys(cart) {
    var items = (cart && cart.items) || [];
    var giftLines = [];
    var nonGiftCount = 0;
    items.forEach(function (it) {
      if (isGiftLine(it)) {
        giftLines.push(it);
      } else {
        nonGiftCount++;
      }
    });

    var keys = [];
    var removeAllGifts = giftLines.length > 0 && nonGiftCount === 0; // nur noch Geschenke -> alle raus
    giftLines.forEach(function (it) {
      if (removeAllGifts || it.final_line_price > 0) {
        keys.push(it.key);
      }
    });
    return keys;
  }

  function sectionInner(html, selector) {
    try {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  // Rendert den Drawer vollstaendig neu – genau wie CartDrawerItems.updateQuantity
  function renderDrawer(state) {
    try {
      var sections = (state && state.sections) || {};
      var empty = state.item_count === 0;

      var wrapper = document.querySelector('cart-drawer');
      var items = document.querySelector('cart-drawer-items');
      if (items) items.classList.toggle('is-empty', empty);
      if (wrapper) wrapper.classList.toggle('is-empty', empty);

      // Innenbereich (Items, Empty-State, Upsell, Footer/Checkout, Progressbar)
      if (sections['cart-drawer']) {
        var innerHTML = sectionInner(sections['cart-drawer'], '.drawer__inner');
        var cd = document.getElementById('CartDrawer');
        var innerTarget = cd ? cd.querySelector('.drawer__inner') : document.querySelector('cart-drawer .drawer__inner');
        if (innerTarget && innerHTML != null) innerTarget.innerHTML = innerHTML;
      }

      // Warenkorb-Badge im Header
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var bHTML = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bHTML != null) bubble.innerHTML = bHTML;
      }
    } catch (e) {}

    try { if (typeof updateProgressUI === 'function') updateProgressUI(); } catch (e) {}

    // Falls die Section-API nichts geliefert hat: sanfter Fallback ueber das Theme-Pub/Sub
    if (!state || !state.sections) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sternify-gift-reconcile' });
        }
      } catch (e) {}
    }
  }

  function reconcile() {
    if (reconciling) return;
    reconciling = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keys = orphanLineKeys(cart);
        if (!keys.length) { reconciling = false; return null; }
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            reconciling = false;
            renderDrawer(state);
          });
      })
      .catch(function () { reconciling = false; });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, delay || CHANGE_DELAY);
  }

  // A) Beim Seitenaufruf einmal pruefen (faengt bereits kaputte Warenkoerbe ab).
  function initialCheck() { schedule(ADD_DELAY); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialCheck);
  } else {
    initialCheck();
  }

  // B) Nach JEDER Warenkorb-Mutation reagieren – egal ob Theme oder Sternify.
  try {
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var input = arguments[0];
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/.test(url)) {
          p.then(function () { schedule(ADD_DELAY); }).catch(function () {});
        } else if (/\/cart\/(change|update|clear)/.test(url)) {
          p.then(function () { schedule(CHANGE_DELAY); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}
})();
